import React, { FC } from 'react'

import { FieldErrors, UseFormClearErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import { UseFormSetValue } from 'react-hook-form/dist/types/form'

import { ErrorTxt } from 'src/components/atoms'
import { TextInput } from 'src/components/atoms/inputs/TextInput'
import { PrefectureDropdown } from 'src/components/molecules'
import { FormItemVertical } from 'src/components/molecules/formSets/FormItemVertical'

import { UpsertProjectFormEntity } from 'src/types'

type Props = {
  register: UseFormRegister<UpsertProjectFormEntity>
  watch: UseFormWatch<UpsertProjectFormEntity>
  setValue: UseFormSetValue<UpsertProjectFormEntity>
  formErrors: FieldErrors<UpsertProjectFormEntity>
  clearErrors: UseFormClearErrors<UpsertProjectFormEntity>
  className?: string
}

export const ProjectLocationInputArea: FC<Props> = ({
  register,
  watch,
  setValue,
  formErrors,
  clearErrors,
  className,
}) => {
  const handleSelectPrefecture = (v: string) => {
    setValue('prefecture', v)
    if (v !== '未選択') {
      clearErrors('prefecture')
    }
  }

  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s2">
        <FormItemVertical title="郵便番号">
          <TextInput placeholder="123-4567" className="tw-w-2/6" {...register('zipcode')} />
        </FormItemVertical>
        <div className="tw-grid tw-gap-r-3">
          <FormItemVertical title="都道府県" showRequired>
            <PrefectureDropdown
              value={watch('prefecture') ?? '未選択'}
              selectOption={handleSelectPrefecture}
              className="tw-w-[10.14rem]"
            />
          </FormItemVertical>
          {formErrors.prefecture && (
            <ErrorTxt text={formErrors.prefecture.message ?? ''} showIcon iconPlacement="left" />
          )}
        </div>
        <FormItemVertical title="市区町村">
          <TextInput
            placeholder="東京都渋谷区神宮前４丁目３−１５"
            {...register('city')}
            className="tw-w-full"
          />
        </FormItemVertical>
        <FormItemVertical title="番地・建物">
          <TextInput
            placeholder="東京セントラル表参道"
            {...register('address')}
            className="tw-w-full"
          />
        </FormItemVertical>
      </div>
    </div>
  )
}
